// src/i18n/en/groups.ts

const groups = {
  name: 'Group |||| Groups',
  
  fields: {
    id: 'ID',
    name: 'Group Name',
    description: 'Description',
    directoryId: 'Registry organization',
    registry: 'Registry',
    hotels: 'Properties',
    totalDevices: 'Total Devices',
    isActive: 'Active',
    hotelCount: 'Property Count',
  },
  
  actions: {
    create: 'Create Group',
    edit: 'Edit Group',
    delete: 'Delete Group',
    view: 'View Group',
    list: 'Groups List',
  },
  
  messages: {
    create_success: 'Group created successfully',
    create_error: 'Error creating group',
    update_success: 'Group updated successfully',
    update_error: 'Error updating group',
    delete_success: 'Group deleted successfully',
    delete_error: 'Error deleting group',
    delete_confirm: 'Are you sure you want to delete this group?',
    delete_with_hotels: 'Cannot delete group with properties assigned',
    no_groups: 'No groups available',
    loading: 'Loading groups...',
  },
  
  validation: {
    name_required: 'Group name is required',
    name_min_length: 'Group name must be at least 3 characters',
    name_max_length: 'Group name cannot exceed 100 characters',
    description_max_length: 'Description cannot exceed 500 characters',
    id_required: 'Group ID is required',
    id_exists: 'A group with this ID already exists',
  },
  
  list: {
    title: 'Groups',
    empty: 'No groups found',
    search: 'Search groups...',
  },
  
  show: {
    title: 'Group Details',
    hotels_section: 'Properties in this Group',
    statistics: 'Statistics',
    no_hotels: 'No properties assigned to this group',
    metadata: 'Metadata',
  },
  
  create: {
    title: 'Create New Group',
    subtitle: 'Add a new property group to the system',
  },
  
  edit: {
    title: 'Edit Group',
    subtitle: 'Modify group information',
  },
};

export default groups;